<nav class="nj-navbar nj-navbar--shadow nj-navbar--expand-xl mb-3">
  <div class="container-fluid">
    <a class="nj-navbar__brand" href="#"><img src="assets/logo-engie-blue.svg" class="nj-navbar__logo"></a>
    <div class="font-weight-bold" [style]="'font-size: 1.25em;'">Automated Instructions Management Portal</div>
    <div id="userInfo">
      <span>{{UserName}}</span>
    </div>
  </div>
</nav>
<div [style]="'padding: 16px;font-family: var(--nj-semantic-font-family-default)'" [style.background]="'#2b3d83'"
  [style.display]="DisplayLoading ? '' : 'none'">
  <nj-spinner variant="inverse" size="xxs" [isLoading]="true"></nj-spinner>
  <div [style]="'color: white; float: left'">Loading ...&nbsp;&nbsp;&nbsp;</div>
</div>
<div class="col-md-11 text-right">
  @if (UserData?.IsTrader || UserData?.HasFHCAccess || UserData?.HasMorayEastAccess || UserData?.HasRetailAccess) {
    <nj-tabs>
    @if(UserData?.IsTrader) {
    <nj-tab (tabSelect)="NavigateTo('Trader_Dashboard')" [isActive]="CurrentTab=='Trader_Dashboard'">
      <ng-container>General Dashboard</ng-container>
    </nj-tab>
    }
    @if(UserData?.IsTrader || UserData?.HasMorayEastAccess) {
    <nj-tab (tabSelect)="NavigateTo('Moweo_Dashboard')" [isActive]="CurrentTab=='Moweo_Dashboard'">
      <ng-container>Moray East</ng-container>
    </nj-tab>
    }
    @if(UserData?.IsTrader || UserData?.HasMorayWestAccess) {
      <nj-tab (tabSelect)="NavigateTo('Mowwl_Dashboard')" [isActive]="CurrentTab=='Mowwl_Dashboard'">
        <ng-container>Moray West</ng-container>
      </nj-tab>
      }
    @if(UserData?.IsTrader || UserData?.HasFHCAccess) {
    <nj-tab (tabSelect)="NavigateTo('FHC_Dashboard')" [isActive]="CurrentTab=='FHC_Dashboard'">
      <ng-container>First Hydro</ng-container>
    </nj-tab>
    }
    @if(UserData?.IsTrader || UserData?.HasRetailAccess) {
    <nj-tab (tabSelect)="NavigateTo('Retail_Dashboard')" [isActive]="CurrentTab=='Retail_Dashboard'">
      <ng-container>Retail</ng-container>
    </nj-tab>
    }
    @if(UserData?.IsTrader || UserData?.HasResAccess) {
    <nj-tab (tabSelect)="NavigateTo('Res_Dashboard')" [isActive]="CurrentTab=='Res_Dashboard'">
      <ng-container>RES</ng-container>
    </nj-tab>
    }
  </nj-tabs>
}
</div>